import routerOptions0 from "/codebuild/output/src1120545451/src/consort-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}